<template>
  <div class="warn-info">
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">预警信息</h2>
      <!--      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改应急队伍</h2>-->
      <Divider/>
      <div style="width: 60%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="预警标题" prop="title">
            <Input v-model="formValidate.title" placeholder="请填写预警标题"></Input>
          </FormItem>
          <FormItem label="预警类型" prop="type">
            <Select transfer v-model="formValidate.type" placeholder="请选择预警类型">
              <Option v-for="(item,index) in warningTypeList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="预警描述" prop="description">
            <Input v-model="formValidate.description" placeholder="请填写预警描述" type="textarea"
                   :autosize="{minRows: 3}"></Input>
          </FormItem>
          <FormItem label="发布区县" prop="countysId">
            <Select transfer multiple clearable v-model="formValidate.countysId" placeholder="发布区县">
              <Option v-for="item in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="生效时间" prop="effectiveDate">
            <DatePicker transfer type="datetime" placeholder="请选择生效时间"
                        v-model="formValidate.effectiveDate"></DatePicker>
          </FormItem>
          <FormItem label="失效时间" prop="expiringDate">
            <DatePicker transfer type="datetime" placeholder="请选择失效时间"
                        v-model="formValidate.expiringDate"></DatePicker>
          </FormItem>
        </Form>
        <div style="text-align: center">
          <Button v-if="!formValidate.id" type="primary" @click="handleSubmit('formValidate',0)" :loading="saveLoading">
            保存
          </Button>
          <Button v-if="formValidate.id" :loading="saveLoading" type="primary" @click="editWarning('formValidate', 0)">
            编辑
          </Button>
          <Button v-if="!formValidate.id" :loading="realeaseLoading" type="primary"
                  @click="handleSubmit('formValidate',1)"
                  style="margin-left: 8px">发布
          </Button>
          <Button v-if="formValidate.id" :loading="realeaseLoading" type="primary"
                  @click="editWarning('formValidate',1)" style="margin-left: 8px">
            发布
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          <Button @click="back" style="margin-left: 8px">返回</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "warnInfo",
  data() {
    return {
      saveLoading: false,
      realeaseLoading: false,
      countryList: [],
      warningTypeList: [],
      formValidate: {
        title: '',
        type: '',
        description: '',
        countysId: '',
        effectiveDate: '',
        expiringDate: ''
      },
      ruleValidate: {
        title: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        countysId: [
          { required: true, message: '必填', type: 'array', trigger: 'change' }
        ],
        effectiveDate: [
          { required: true, type: 'date', message: '必填', trigger: 'blur' }
        ],
        expiringDate: [
          { required: true, type: 'date', message: '必填', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getCountry()
    this.getWarningType()
    if (this.$route.params.row) {
      this.formValidate = this.$route.params.row
      this.formValidate.countysId = this.formValidate.countysId.split(',')
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'warningRelease'
      })
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts').then(res => {
        // console.log(res)
        this.countryList = res.data
      })
    },
    //预警类型
    getWarningType() {
      this.$http.get('/api/earlyWarningTypes').then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.warningTypeList = res.data.data
        }
      })
    },
    handleSubmit(name, status) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (status === 0) {
            this.saveLoading = true
          } else {
            this.realeaseLoading = true
          }
          var str = this.formValidate.countysId
          let params = { ...this.formValidate }
          params.countysId = str.toString()
          params.status = status
          // console.log(params)
          this.$http.post('/api/emergencyWarnings', params).then(res => {
            if (res.status === 200 || res.status === 201) {
              if (status === 0) {
                this.saveLoading = false
              } else {
                this.realeaseLoading = false
              }
              this.$Message.success('新增完成！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'warningRelease'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('请填写！');
        }
      })
    },
    editWarning(name, status) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (status === 0) {
            this.saveLoading = true
          } else {
            this.realeaseLoading = true
          }
          var str = this.formValidate.countysId
          let params = { ...this.formValidate }
          params.countysId = str.toString()
          params.status = status
          this.$http.put('/api/emergencyWarnings', params).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('修改完成！')
              if (status === 0) {
                this.saveLoading = false
              } else {
                this.realeaseLoading = false
              }
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'warningRelease'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('填写错误');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped>

</style>
